import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiChevronDown } = FiIcons;

export const Select = ({ label, options, value, onChange, className = "", placeholder = "Select option..." }) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && <label className="text-xs font-semibold text-brand-muted uppercase tracking-wider">{label}</label>}
      <div className="relative group">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full appearance-none px-4 py-2.5 bg-brand-light/30 border border-brand-border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent/20 transition-all text-sm cursor-pointer pr-10 hover:border-brand-accent/50"
        >
          <option value="" disabled>{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-brand-muted group-hover:text-brand-accent transition-colors">
          <SafeIcon icon={FiChevronDown} />
        </div>
      </div>
    </div>
  );
};